import React, { useState } from "react";
import { Loader2Icon, DownloadIcon, ExternalLinkIcon } from "lucide-react";
import Modal from "./modal";
import { XIcon, ChevronDownIcon } from "lucide-react";
import toast from "react-hot-toast";
import server from "../utils/serverConfig";

const GenerateMetrics = ({ setShowModal, handleCloseModal }) => {
  const [file, setFile] = useState(null);
  const [fileProcessing, setFileProcessing] = useState(false);
  const [isError, setIsError] = useState(false);

  const serverUrl =`${server.godseye.baseUrl}metrics` ;
  // const devUrl = "https://godseye.server.sypto.xyz/metrics";

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    setFileProcessing(true);
    if (file) {
      const formData = new FormData();
      formData.append("file", file);

      try {
        const response = await fetch(serverUrl, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();

        console.log("Data is -------->", JSON.stringify(data));
        setFileProcessing(false);
        setShowModal(false);
        toast.success("Metrics generated successfully !!", {
          style: {
            minWidth: "250px",
          },
          duration: 5000,
        });
      } catch (error) {
        console.error("Error uploading file:", error);
        setFileProcessing(false);
        setIsError(true);
        toast.error(
          "Server Error,Something went Wrong !!",

          {
            style: {
              minWidth: "250px",
            },
            duration: 15000,
          }
        );
      }
    } else {
      console.warn("No file selected!");
    }
  };

  return (
    <Modal>
      <div className="relative overflow-auto sm:overflow-hidden">
        <button
          onClick={handleCloseModal}
          className="absolute top-4 right-2 p-1 md:top-6 md:right-8 bg-white rounded-md md:p-1"
        >
          <XIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-900" />
        </button>
        <div className="flex flex-col space-y-8 justify-center items-center w-[460px] h-[250px] flex-1 bg-zinc-900 py-6 px-8 rounded-lg">
          <p className="text-2xl font-semibold text-white ">
            Upload Trade Data
          </p>
          <div className="flex flex-col space-y-6 ">
            <div className="flex flex-col w-[400px] space-y-6 items-center  p-4 ">
              <input
                type="file"
                onChange={handleFileChange}
                className="text-white font-medium w-full  file:mr-10 file:py-2 file:px-4 file:bg-[#07F2C7]/20 file:font-semibold file:border-none file:rounded-md file:text-white hover:file:bg-[#07F2C7]/30"
              />

              <button
                onClick={handleUpload}
                className={`${isError ? "bg-red-200 text-red-600 hover:bg-red-300" : "bg-[#07F2C7] hover:bg-[#07F2C7]/80"} w-full  text-lg text-black font-bold py-2 px-4 rounded`}
              >
                {fileProcessing ? (
                  <div className="flex space-x-2 items-center justify-center">
                    <Loader2Icon className="h-5 w-5 animate-spin" />
                    <span>Generating Metrics...</span>
                  </div>
                ) : !fileProcessing && isError ? (
                  <div className="flex space-x-2 items-center justify-center">
                    <span>!! Error - Please Check File Data</span>
                  </div>
                ) : (
                  "Upload File"
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default GenerateMetrics;
